var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.81323 1C5.81323 0.446875 6.26021 0 6.81347 0H7.81371C8.36697 0 8.81395 0.446875 8.81395 1V5.40312L12.6274 3.20312C13.1056 2.92812 13.7183 3.09062 13.9933 3.56875L14.4935 4.43437C14.7685 4.9125 14.606 5.525 14.1277 5.8L10.3143 8L14.1277 10.2C14.606 10.475 14.7716 11.0875 14.4935 11.5656L13.9933 12.4312C13.7183 12.9094 13.1056 13.075 12.6274 12.7969L8.81395 10.5969V15C8.81395 15.5531 8.36697 16 7.81371 16H6.81347C6.26021 16 5.81323 15.5531 5.81323 15V10.5969L1.99981 12.8C1.52157 13.075 0.908919 12.9125 0.633852 12.4344L0.133731 11.5688C-0.141335 11.0906 0.0212041 10.4781 0.499445 10.2031L4.31287 8L0.499445 5.8C0.0212041 5.525 -0.141335 4.9125 0.133731 4.43437L0.633852 3.56875C0.908919 3.0875 1.52157 2.925 1.99981 3.2L5.81323 5.4V1Z",
    fill: "#2D65F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryIcon3);
export default __webpack_public_path__ + "static/media/category_icon3.2b87f3e1ce692e3d8a228aba9a49f90a.svg";
export { ForwardRef as ReactComponent };